<template>
  <div>
      <div class="main_i" v-lazy:background-image="{src: lazyImg.bgc3}">
        <div class="content">
            <!-- logo--start -->
            <div class="logo">
                <a href="https://www.pcauto.com.cn/" class="logo_tpy">
                <img src="https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/logo_tpy.png" alt="">
                </a>
                <a href="https://www.geeknev.com/" class="logo_jd">
                <img src="https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/logo_jd.png" alt="">
                </a>
            </div>
            <!-- logo--end -->

            <!-- 前瞻，独家，权威--start -->
            <div class="advantage fl-ai-jcb">
                <div  v-for="(item, index) in advantage" :key="index" class="ad_item fl-ai">
                    <div class="ad_img"><img v-lazy="item.picImg" :key="item.picImg" alt=""></div>
                    <div class="ad_text">
                        <h5>{{item.title || ""}}</h5>
                        <p>{{item.detail || ""}}</p>
                    </div>
                </div>
            </div>
            <!-- 前瞻，独家，权威--end -->

            <!-- 为什么做这个--start -->
            <div class="whydo">
                <div class="whydo_t"></div>
                <div class="whydo_b" v-lazy:background-image="{src: lazyImg.border9}">
                    <p>{{whydo || ""}}</p>
                </div>
            </div>
            <!-- 为什么做这个--end -->

            <!-- 评测对象--start -->
            <div class="testObj">
                <div class="testObj_t"></div>
                <div class="testObj_outerbox" v-lazy:background-image="{src: lazyImg.border10}">
                    <div class="testObj_box">
                        <div class="testObj_b">
                            <div v-for="(item,index) in brandLogo" :key="index" class="testObj_b_item">
                                <div class="testObj_img">
                                    <img v-lazy="item" :key="item" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <i class="testObj_moveL" v-show="brandLogo.length>4" @click="rollTestObj($event,'left')"></i>
                    <i class="testObj_moveR" v-show="brandLogo.length>4" @click="rollTestObj($event,'right')"></i>
                </div>
            </div>
            <!-- 评测对象--end -->

            <!-- 评测的内容--start -->
            <div class="testcontent">
                <div class="testc_t"></div>
                <div class="testc_b" v-lazy:background-image="{src: lazyImg.border11}">
                    <div class="testc_text">
                        <p>300分</p>
                        <p>150+100+50</p>
                        <p>完美评分=自动驾驶+智能座舱+性能</p>
                    </div>
                </div>
                <div class="testc_system fl-ai-jcb">
                    <div v-for="(item,index) in evalSystem" :key="index" class="testc_system_item">
                        <div class="system_item_t" v-lazy:background-image="{src: lazyImg.subtitle6}">
                            <i>{{item.score}}分</i>
                            <em>{{item.name}}</em>
                        </div>
                        <div class="system_item_b" v-lazy:background-image="{src: lazyImg.border12}">
                            <div class="collapse_outerbox" :style="{height:item.ItemList.length*48+'px'}" >
                                <div id="scroll_bar" style="height:450px">
                                    <div class="system_collapse" >
                                        <el-collapse :v-model="activeName+index" accordion @change="changeColl()">
                                            <div v-for="(item2,index2) in item.ItemList" :key="index2" class="sub_score_box" id="score_box">
                                                <el-collapse-item :title="item2.name" :name="index2+1">
                                                        <el-collapse :v-model="activeName+index2" accordion @change="changeColl()">
                                                            <div v-for="(item3,index3) in item2.detailList" :key="index3" class="sub_score_item">
                                                            <i v-if="item3.scoreList.length<1">{{item3.name}}</i>
                                                            <el-collapse-item :title="item3.name" :name="index3+1" v-if="item3.scoreList.length>0">
                                                                <div v-for="(item4,index4) in item3.scoreList" :key="index4" class="sub_score_item_2">
                                                                    {{item4}}
                                                                </div>
                                                            </el-collapse-item>
                                                            </div>
                                                        </el-collapse>
                                                </el-collapse-item>
                                            </div>
                                        </el-collapse>
                                    </div>
                                </div>
                            </div>
                            <div class="system_intro">
                                <p>{{item.intro}}</p>
                                <img v-lazy="item.picImg" :key="item.picImg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 评测的内容--end -->

            <!-- 智能汽车前景--start -->
            <div class="prospect">
                <div class="prospect_t"></div>
                <div class="prospect_b" v-lazy:background-image="{src: lazyImg.border13}">
                    <p>{{prospect}}</p>
                </div>
            </div>
            <!-- 智能汽车前景--end -->
            <!-- 二维码 -->
            <div class="qrcode">
                <img src="https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/qrcode.png" alt="">
                <p>想了解评测内容请扫描二维码</p>
            </div>
        </div>
      </div>
  </div>

</template>
<script>
import "@/tool/jquery.cookie.js"
export default {
    components: {
    },
    data() {
        return {
            lazyImg:{
                bgc3:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/bgc3.jpg",
                border9:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border9.png",
                border10:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border10.png",
                border11:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border11.png",
                subtitle6:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/subtitle6.png",
                border12:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border12.png",
                border13:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border13.png",
            },
            activeName:0,
            activeName:0,
            advantage:[
                {
                    picImg:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/adv_qz.png",
                    title:"前瞻",
                    detail:"前瞻意义的测试标准揭示智能汽车方向"
                },
                {
                    picImg:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/adv_dj.png",
                    title:"独家",
                    detail:"与上海智能网联汽车技术中心形成战略合作"
                },
                {
                    picImg:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/adv_qw.png",
                    title:"权威",
                    detail:"权威机构与太平洋汽车专业评测团队联合"
                }
            ],
            whydo:"回看过去十年间，汽车产业发生的重大变革，得益于国家坚定不移的纯电动路线，国内新能源产业取得了飞速发展，智能汽车也成为了新的焦点。因此一个关乎用户、关于技术、关于行业的智能化评测标准也需应运而生。极智+评测体系的建立，不仅仅服务消费者买车用车，还能推动行业技术开发水平进步，服务国家智能汽车健康发展。",
            brandLogo:[
                "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/brandLogo1.jpg",
                "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/brandLogo2.jpg",
                "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/brandLogo3.jpg",
                "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/brandLogo4.jpg",
                "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/brandLogo5.jpg",
                "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/brandLogo6.jpg",
            ],
            evalSystem:[
                {
                    name:"自动驾驶评价体系",
                    score:"150",
                    intro:"自动驾驶能力分数占比较高，是对未来实现“无人驾驶”愿景的体现。测试从硬件标准、场地科目、OTA以及开放道路测试多维度进行。联合上海智能网联基地，采用目前国际领先的测试场地、设备以及流程进行，实现准确、客观、全面地对自动驾驶能力进行评测。",
                    picImg:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/illustration1.png",
                    ItemList:[
                        {
                            name:"传感器",
                            score:10,
                            detailList:[
                                {
                                    name:"配备微波雷达",
                                    scoreList:["无0分","有2分"]
                                },
                                {
                                    name:"配备毫米波雷达",
                                    scoreList:["无0分","有2分"]
                                },
                                {
                                    name:"微波雷达、毫米波雷达搭配远距离高清摄像头",
                                    scoreList:["无0分","有远距离高清摄像头4分"]
                                },
                                {
                                    name:"微波雷达、毫米波雷达搭配远距离高清摄像头与激光雷达",
                                    scoreList:["无0分","有激光雷达2分"]
                                }
                            ]
                        },
                        {
                            name:"可实现功能（封闭场地单项测试）",
                            score:80,
                            detailList:[
                                {
                                    name:"高速弯车道保持",
                                    scoreList:["无0分","能够居中2分"]
                                },
                                {
                                    name:"主动刹车",
                                    scoreList:["无0分","有2分"]
                                },
                                {
                                    name:"特殊地形的识别（桩桶道路收窄）",
                                    scoreList:["无识别0分","能够识别or预警2分","有主动规避动作4分"]
                                },
                                {
                                    name:"自适应巡航能力",
                                    scoreList:["有限定速度的续航2分","全速域的巡航2分"]
                                },
                                {
                                    name:"全速域自适应巡航下的能力",
                                    scoreList:["车道保持功能2分","车距是否可调2分","能够减速至0后再起步2分"]
                                },
                                {
                                    name:"高低难度两个场景的自动泊车能力",
                                    scoreList:["倒车入库项目测试成功得6分","有侧方障碍的停车侧方位测试成功得8分"]
                                },
                                {
                                    name:"给予指令后自动完成变道",
                                    scoreList:["有变道功能2分","无后车时变道是否迅速2分"]
                                },
                                {
                                    name:"自我完成变道（地图导航能力）",
                                    scoreList:["不支持0分","支持地图导航状态下的自动变道4分"]
                                },
                                {
                                    name:"自动驾驶辅助状态中可上匝道",
                                    scoreList:["不支持0分","支持地图导航状态下的匝道识别进入8分"]
                                },
                                {
                                    name:"复杂场景的行人识别与规避",
                                    scoreList:["40km/h续航移动假人（成人）横穿马路测试，通过得6分","40km/h移动假人（成人）鬼探头测试，通过得8分","50km/h固定假人（小孩）测试，通过得6分"]
                                },
                                {
                                    name:"复杂场景的车辆紧急加塞识别与规避",
                                    scoreList:["能够识别或警示2分","能够做出明显减速的规避动作2分","避免碰撞4分"]
                                },
                                {
                                    name:"复杂场景隧道内障碍车的识别与规避",
                                    scoreList:["不通过测试0分","通过4分"]
                                }
                            ]
                        },
                        {
                            name:"升级能力",
                            score:20,
                            detailList:[
                                {
                                    name:"车机类功能的更新",
                                    scoreList:["仅支持车机功能的OTA 5分"]
                                },
                                {
                                    name:"能够基于传感器等硬件，对自动驾驶、性能、全新功能方面进行升级",
                                    scoreList:["空调、锁车等常规控制进行更新5分","调用传感器对自动驾驶能力进行更新5分","调用传感器对加速、制动性能进行更新5分"]
                                }
                            ]
                        },
                        {
                            name:"完全自动驾驶主观感受（开放道路综合测试）",
                            score:40,
                            detailList:[
                                {
                                    name:"自动泊车感受（准确度、速度、适应能力）",
                                    scoreList:["车位识别是否迅速3分","停车过程是否准确、迅速3分","自动泊车功能的易用程度4分"]
                                },
                                {
                                    name:"自适应巡航感受（跟线、过弯准确度、自然程度）",
                                    scoreList:["高速弯车道居中是否准确2分","加减速是否自然4分","综合体验、拟人化程度4分"]
                                },
                                {
                                    name:"完全自动驾驶辅助感受（为驾驶人分担程度）",
                                    scoreList:["能够在普通巡航、变道等少部分工况中为人工分担5分","能够在复杂工况下为人工分担5分"]
                                },
                                {
                                    name:"特殊功能（如智能召唤、赛道模式、自适应进入匝道收费站高难度进阶）",
                                    scoreList:["召唤功能2分","赛道模式2分","自动识别进入收费站6分"]
                                }
                            ]
                        },
                    ]
                },
                {
                    name:"智能座舱评价体系",
                    score:"100",
                    intro:"汽车不再是单纯的出行工具，它将会具备交互体验的智能终端。随着车联网、5G、人工智能等发展，更多单独的个体将被协同聚合。遵循用户体验的立意，借助集团站在IT行业的经验，开发出适合未来数年的智能驾舱评价体系，并且通过数像化的结果直接呈现。",
                    picImg:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/illustration2.png",
                    ItemList:[
                        {
                            name:"屏幕效果",
                            score:10,
                            detailList:[
                                {
                                    name:"尺寸",
                                    scoreList:["5-7英寸 1分","7-14英寸 2分","＞14英寸 3分"]
                                },
                                {
                                    name:"分辨率",
                                    scoreList:["短边像素＜720 1分","短边像素＞720 2分"]
                                },
                                {
                                    name:"可视角度与亮度",
                                    scoreList:["屏幕有明显反光且影响观看 0分","有明显反光但不影响观看 1分","无明显反光 2分","完全不反观 3分"]
                                },
                                {
                                    name:"屏幕盖板玻璃，防划涂层",
                                    scoreList:["明显划痕 0分","细微划痕 0分","无划痕（特殊涂层） 0分"]
                                }
                            ]
                        },
                        {
                            name:"车机性能",
                            score:10,
                            detailList:[
                                {
                                    name:"系统流畅程度",
                                    scoreList:["有明显掉帧或等待时间过长 0-5分","否则按实际情况 5-10分"]
                                },
                                {
                                    name:"易用性、UI交互设计",
                                    scoreList:["*分数叠加项目，最高叠加10分","空调、导航的打开步骤少于2步 2分","自带音乐播放器、车辆设置放在第一屏 2分","具备快捷通知/快捷设置栏 1分","主观评价 0-5分"]
                                },
                                {
                                    name:"中控屏幕功能丰富度，体验效果",
                                    scoreList:["*分数叠加项目，最高叠加10分","在线地图1分 在线音乐播放器/视频播放器1分","车辆能耗信息0-2分 360行车影像0-2分","主观评价 0-4分"]
                                },
                                {
                                    name:"仪表盘功能丰富程度",
                                    scoreList:["*分数叠加项目，最高叠加8分","能耗信息显示（包括生育续航、平均电耗）1分","音乐播放器显示1分 车辆设置1分 导航信息显示1分","主观评价 0-4分"]
                                },
                                {
                                    name:"扩展性第一部分（中控屏幕）",
                                    scoreList:["无软件商城0分 有软件商城但可下载软件很少1分","软件商城可下载软件很多（像手机一样多）2分"]
                                },
                                {
                                    name:"扩展性第二部分（手机互联）",
                                    scoreList:["*分数叠加项目，最高叠加5分","苹果手机映射 2分","安卓手机映射 2分","支持无线映射 1分"]
                                }
                            ]
                        },
                        {
                            name:"语音交互",
                            score:35,
                            detailList:[
                                {
                                    name:"常规功能支持",
                                    scoreList:["*分数叠加项目，最高叠加14分","支持导航唤醒并导航到指定目的地2分","温度调节2分 车窗调节2分 点播音乐以及调音量2分","主观评价 0-6分"]
                                },
                                {
                                    name:"识别速度、纠错能力",
                                    scoreList:["识别速度0-3分","粤式普通话纠错能力0-6分（每句得2分）"]
                                },
                                {
                                    name:"具有多轮对话，语句联想能力",
                                    scoreList:["每句得2分，共12分"]
                                }
                            ]
                        },
                        {
                            name:"智能化进阶需求",
                            score:10,
                            detailList:[
                                {
                                    name:"智能化、情感化、有温度",
                                    scoreList:["主观评价 0-2分"]
                                },
                                {
                                    name:"OTA，更新频率以及更新内容",
                                    scoreList:["主观评价 0-2分"]
                                },
                                {
                                    name:"人机趣味性（彩蛋、游戏、KTV）",
                                    scoreList:["主观评价 0-2分"]
                                },
                                {
                                    name:"手机远程操控",
                                    scoreList:["*分数叠加项目，最高叠加2分","支持开天窗开空调1分","支持遥控挪车/泊车1分"]
                                },
                                {
                                    name:"辅助驾驶信息输出丰富程度",
                                    scoreList:["主观评价 0-2分（包括路况识别、车辆状态、路牌显示/美观度，限速显示/美观度，方向盘震动，声音提示）"]
                                }
                            ]
                        }
                    ]
                },
                {
                    name:"汽车性能评价体系",
                    score:"50",
                    intro:"18年汽车专业评测经验，针对消费者最具有价值的汽车性能指标进行权威评测。参考国内外权威机构的性能评测标准，结合多年评测经验；借助P-box等专业仪器以及经验丰富的专业评测人员，针对汽车加速、制动、操控、极限性能和噪音等多维度评价。",
                    picImg:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/illustration3.png",
                    ItemList:[
                        {
                            name:"0-100km/h加速",
                            score:10,
                            detailList:[
                                {
                                    name:"测试数据≥12",
                                    scoreList:["测试数据≥12  0分"]
                                },
                                {
                                    name:"12秒＞测试数据≥8秒",
                                    scoreList:["12秒＞测试数据≥10秒   1分","10秒＞测试数据≥8秒   2分"]
                                },
                                {
                                    name:"8秒＞测试数据≥7秒",
                                    scoreList:["8秒＞测试数据≥7秒    3分"]
                                },
                                {
                                    name:"7秒＞测试数据≥4秒",
                                    scoreList:["7秒＞测试数据≥6.5秒   4分","6.5秒＞测试数据≥6秒   5分","6秒＞测试数据≥5.5秒   6分","5.5秒＞测试数据≥5秒   7分","5秒＞测试数据≥4.5秒   8分","4.5秒＞测试数据≥4秒   9分"]
                                },
                                {
                                    name:"4秒＞测试数据",
                                    scoreList:["4秒＞测试数据         10分"]
                                }
                            ]
                        },
                        {
                            name:"100-0km/h制动",
                            score:10,
                            detailList:[
                                {
                                    name:"测试数据≥45米",
                                    scoreList:["测试数据≥45米         0分"]
                                },
                                {
                                    name:"45米＞测试数据≥42米",
                                    scoreList:["45米＞测试数据≥42米   1分"]
                                },
                                {
                                    name:"42米＞测试数据≥40米",
                                    scoreList:["42米＞测试数据≥40米   2分"]
                                },
                                {
                                    name:"40米＞测试数据≥35米",
                                    scoreList:["40米＞测试数据≥39米   3分","39米＞测试数据≥38米   4分","38米＞测试数据≥37米   5分","37米＞测试数据≥36米   6分","36米＞测试数据≥35米   7分"]
                                },
                                {
                                    name:"35米＞测试数据≥34米",
                                    scoreList:["35米＞测试数据≥34.5米 8分","34.5米＞测试数据≥34米 9分"]
                                },
                                {
                                    name:"34米＞测试数据 =10分",
                                    scoreList:["34米＞测试数据         10分"]
                                }
                            ]
                        },
                        {
                            name:"18m蛇形绕桩（60km/h）",
                            score:10,
                            detailList:[
                                {
                                    name:"车身姿态（侧倾程度、车身跟随性等表现评价）",
                                    scoreList:["无法通过所有桩桶 0分","侧倾严重、出现明显滑动，仅勉强通过所有桩桶 1分","侧倾明显，出现滑动，基本保持走线，并通过所有桩桶  2分","侧倾一般，无滑动，轻松保持走线，并通过所有桩桶  3分","侧倾小，跟随性好，较轻松通过所有桩桶  4分","侧倾极小、跟随性极好，轻松通过所有桩桶 5分"]
                                },
                                {
                                    name:"转向手感（助力反馈、指向性、响应性等主观评价）",
                                    scoreList:["极差 0分","差  1分","一般 2分","良好 3分","较好 4分","极好 5分"]
                                }
                            ]
                        },
                        {
                            name:"麋鹿测试",
                            score:10,
                            detailList:[
                                {
                                    name:"56km/h＞测试数据",
                                    scoreList:["56km/h＞测试数据           0分"]
                                },
                                {
                                    name:"56km/h≥测试数据＞64km/h",
                                    scoreList:["56km/h≥测试数据＞60km/h   1分","60km/h≥测试数据＞64km/h   2分"]
                                },
                                {
                                    name:"64km/h≥测试数据＞72km/h",
                                    scoreList:["64km/h≥测试数据＞66km/h   3分","66km/h≥测试数据＞68km/h   4分","68km/h≥测试数据＞70km/h   5分","70km/h≥测试数据＞72km/h   6分"]
                                },
                                {
                                    name:"72km/h≥测试数据＞75km/h",
                                    scoreList:["72km/h≥测试数据＞73km/h   7分","73km/h≥测试数据＞74km/h   8分","74km/h≥测试数据＞75km/h   9分"]
                                },
                                {
                                    name:"测试数据≥75km/h",
                                    scoreList:["测试数据≥75km/h           10分"]
                                }
                            ]
                        },
                        {
                            name:"噪音测试",
                            score:10,
                            detailList:[
                                {
                                    name:"环境噪音与怠速状态的差",
                                    scoreList:["10分贝＞差值             0分","10分贝≥差值＞12分贝     1分","差值≥12分贝             2分"]
                                },
                                {
                                    name:"怠速噪音",
                                    scoreList:["测试数据≥42分贝         0分","40分贝≥测试数据＞42分贝 1分","40分贝＞测试数据         2分"]
                                },
                                {
                                    name:"60km/h噪音",
                                    scoreList:["测试数据≥58分贝         0分","56分贝≥测试数据＞58分贝 1分","56分贝＞测试数据         2分"]
                                },
                                {
                                    name:"90km/h噪音",
                                    scoreList:["测试数据≥62分贝         0分","60分贝≥测试数据＞62分贝 1分","60分贝＞测试数据         2分"]
                                },
                                {
                                    name:"120km/h噪音",
                                    scoreList:["测试数据≥66分贝         0分","64分贝≥测试数据＞66分贝 1分","64分贝＞测试数据         2分"]
                                }
                            ]
                        },
                    ]
                }
            ],
            prospect:"或许当你看到最新的榜单，那些所测试的某项成绩，仅仅只能代表它从前的表现，其实它们每天都在进步，从不停歇。智能汽车的不断进步，将是未来移动出行变革重要的一环。",
            scrollbar:"",
        }
    },
    mounted() {
    },
    methods: {
        rollTestObj(e,type){
            var that = this;
            if(!that.isMove){
                var outerbox = $(e.currentTarget.parentElement).parent();;
                var boxElement = outerbox.find(".testObj_b");
                var itemElement = boxElement.find(".testObj_b_item");
                var itemWidth = itemElement.css("width").substring(0,itemElement.css("width").indexOf("p"));
                var itemMR = itemElement.css("marginRight").substring(0,itemElement.css("marginRight").indexOf("p"));
                var moveLength = (itemWidth-0) + (itemMR-0);
                var allMoveLength = moveLength * (itemElement.length-4);
                moveLength = moveLength*4;
                var left = boxElement.css("left").substring(0,boxElement.css("left").indexOf("p"));
                // console.log("left",left,moveLength,allMoveLength,type,boxElement)
                this.animateFun(left,moveLength,allMoveLength,type,boxElement,800,()=>{
                    if(type == "right"){
                        that.isMove = false;
                    }else{
                        that.isMove = false;
                    }
                })
            }
        },
        // 移动封装
        // left：当前的left值,moveLength：一次移动的长度，allMoveLength：总共能移动的距离，type：左移还是右移，boxElement：移动的对象，time:移动的时间，fun:回调函数
        animateFun(left,moveLength,allMoveLength,type,boxElement,time,fun=null){
            var that = this;
            if(Math.abs(left-0)<allMoveLength-5 && type == "right"){
                that.isMove = true;
                boxElement.animate({left:left-moveLength},  
                time,
                "linear",
                function() {
                    fun()
                });
            }
            if(Math.abs(left-0)>5 && type == "left"){
                that.isMove = true;
                boxElement.animate({left:left-0+moveLength},  
                time,
                "linear",
                function() {
                    fun()
                });
            }
        },
        changeColl(){
            
        }
    }
}
</script>
<style lang="less">
  .main_i{
    padding-bottom: 50px;
    margin-bottom: 40px;
    background-color:  #051338;
    background-position: center top;
    background-repeat: no-repeat;
    min-width: 1180px;
    width: 100%;
    color: #d8fcff;
    height: 3699px;
    .content{
        max-width: 1180px;
        min-width: 960px;
        margin:0 auto;
        height: 3699px;
        position: relative;
        .logo{
            padding-top: 24px;
            .logo_tpy{
            width: 175px;
            height: 40px;
            display: inline-block;
            position: relative;
            top: 23px;
            margin-right: 48px;
            cursor: pointer;
            }
            .logo_jd{
            width: 119px;
            height: 63px;
            display: inline-block;
            cursor: pointer;
            }
        }
        .advantage{
            width: 100%;
            margin-top: 380px;
            .ad_item{
                width: 380px;
                background: rgba(10,29,72,0.5);
                height: 165px;
                padding: 20px;
                box-sizing: border-box;
                overflow: hidden;
                .ad_img{
                    margin-right:20px;
                    img{

                    }
                }
                .ad_text{
                    h5{
                        font-size: 28px;
                        line-height: 45px;
                    }
                    p{
                        color: #e5e0ff;
                        width: 177px;
                    }
                }
            }
        }
        .whydo{
            .whydo_t{
                background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/subtitle3.png) no-repeat center;
                width: 457px;
                height: 62px;
                margin:80px auto 35px;
            }
            .whydo_b{
                background-position: center top;
                background-repeat: no-repeat;
                width: 1182px;
                height: 178px;
                margin:0 auto;
                padding: 50px 75px;
                box-sizing: border-box;
                p{
                    line-height: 30px;
                }
            }
        }
        .testObj{
          .testObj_t{
            background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/subtitle4.png) no-repeat center;
            width:457px;
            height: 62px;
            margin: 80px auto 35px;
          }
          .testObj_outerbox{
            background-position: center top;
            background-repeat: no-repeat;
            width: 1182px;
            height: 276px;
            margin:0 auto;
            position: relative;
            padding: 45px 28px;
            box-sizing: border-box;
            .testObj_box{
              width: 100%;
              overflow: hidden;
              .testObj_b{
                display:flex;
                width: 8000px;
                position: relative;
                .testObj_b_item{
                    display: inline-block;
                    margin-right: 15px;
                    width: 270px;
                    height: 180px;
                    .testObj_img{
                        width: 270px;
                        height: 180px;
                        position: relative;
                        overflow: hidden;
                        margin-bottom: 15px;
                        border-radius: 5px;
                        img{
                            width: 100%;
                            position: absolute;
                            top: 50%;
                            transform: translate(0,-50%);
                        }
                    }
                    
                    h5{
                      line-height: 30px;
                      margin-bottom: 10px;
                    }
                    h6{
                      font-size: 14px;
                      color:#2e6d90;
                    }
                }
              }
            }
            .testObj_moveL{
              background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/arrow_l2.png) no-repeat center;
              width: 41px;
              height: 125px;
              position: absolute;
              top:50%;
              left:-50px;
              transform: translate(0,-50%);
              z-index: 10;
            }
            .testObj_moveR{
              background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/arrow_r2.png) no-repeat center;
              width: 41px;
              height: 125px;
              position: absolute;
              top:50%;
              right:-50px;
              transform: translate(0,-50%);
              z-index: 10;
            }
          }
        }
        .testcontent{
            .testc_t{
                background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/subtitle5.png) no-repeat center;
                width: 457px;
                height: 62px;
                margin:80px auto 35px;
            }
            .testc_b{
                background-position: center top;
                background-repeat: no-repeat;
                width: 1182px;
                height: 623px;
                margin:0 auto;
                .testc_text{
                    position: relative;
                    top: 429px;
                    text-align: center;
                    p:nth-of-type(1){
                        font-size: 40px;
                        font-weight: 700;
                    }
                    p:nth-of-type(2){
                        font-size: 24px;
                        font-weight: 700;
                    }
                    p:nth-of-type(3){
                        font-size: 18px;
                        color: #ddf0ff;
                        margin-top: 34px;
                    }
                }
            }
            .testc_system{
                margin-top: 20px;
                .testc_system_item{
                    width: 391px;
                    .system_item_t{
                        background-position: center top;
                        background-repeat: no-repeat;
                        width: 391px;
                        height: 88px;
                        i{
                            font-size: 30px;
                            font-weight: 700;
                            line-height: 88px;
                            margin-right: 26px;
                            margin-left: 20px;
                        }
                        em{
                            font-size: 23px;
                            font-weight: 700;
                            line-height: 88px;
                        }
                    }
                    .system_item_b{
                        background-position: center top;
                        background-repeat: no-repeat;
                        width: 384px;
                        height: 496px;
                        padding: 25px 20px;
                        overflow: hidden;
                        .collapse_outerbox{
                            // height: 100px;
                            margin-bottom: 10px;
                            .scroll_bar{
                                height: 450px;
                            }
                            .system_collapse{
                                position: relative;
                                z-index: 10;
                                border-top: 1px solid #47d8e3;
                                border-radius: 5px;
                                overflow-y: auto;
                                height: 450px;
                                width: 344px;
                                .el-collapse{
                                    border-top: 0;
                                    border-bottom: 0;
                                    .el-collapse-item{
                                        // border-bottom: 1px solid #123266;
                                        .el-collapse-item__header{
                                            background-color: #1f5093;
                                            background: #1f5093;
                                            font-size: 14px;
                                            color: #fff;
                                            border-bottom: 0;
                                            line-height: 22px;
                                            // height: 40px;
                                            padding: 10px 0 10px 20px;
                                            // padding-left: 20px;
                                            font-weight: 700;
                                            height: 48px;
                                            .el-collapse-item__arrow{
                                                font-size: 16px;
                                            }
                                        }
                                        .el-collapse-item__wrap{
                                            background-color: #1f5093;
                                            padding-left: 20px;
                                            padding-right: 10px;
                                            border-bottom: 0;
                                            .el-collapse-item__content{
                                                padding-bottom: 0;
                                                .sub_score_item_2{
                                                    font-size: 12px;
                                                    color: #fff;
                                                    // line-height: 40px;
                                                    // height: 40px;
                                                    border-bottom: 1px solid #325e9c;
                                                    padding: 5px 0;
                                                    line-height: 21px;
                                                }
                                                .sub_score_item_2:nth-last-of-type(1){
                                                     border-bottom: 0;
                                                }
                                            }
                                        }
                                    }
                                    
                                }
                                #score_box.sub_score_box:nth-of-type(2n){
                                    .el-collapse-item__header{
                                        background-color: #3a6dd3;
                                        background: #3a6dd3;
                                    }
                                    .el-collapse-item__wrap{
                                        background-color: #3a6dd3;
                                        .sub_score_item{
                                            border-bottom: 1px solid #4e7cd8;
                                        }
                                        .sub_score_item_2{
                                            border-bottom: 1px solid #4e7cd8;
                                        }
                                        .sub_score_item_2:nth-last-of-type(1){
                                                border-bottom: 0;
                                        }
                                    }
                                }
                                #score_box.sub_score_box{
                                    .sub_score_item{
                                        padding: 10px 0;
                                        border-bottom: 1px solid #325e9c;
                                        .el-collapse-item__header{
                                            // padding-left:10px;
                                            line-height: 22px;
                                            height: 100%;
                                            font-size: 12px;
                                            padding: 0 0 0 10px;
                                        }
                                    }
                                } 
                                .sub_score_box{
                                    position: relative;
                                    .sub_allscore{
                                        position: absolute;
                                        top: 42px;
                                        right: 50px;
                                        color: #fff;
                                        font-size: 24px;
                                        color:#379cae;
                                        i{
                                            font-size: 32px;
                                            color:#fff;
                                        }
                                    }
                                    .sub_score_item{
                                        font-size: 20px;
                                        color: #fff;
                                        line-height: 21px;
                                        .right_score{
                                            font-size: 20px;
                                            color:#379cae;
                                            i{
                                                color:#fff;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .system_intro{
                            display: flex;
                            p{
                                line-height: 26px;
                                font-size: 14px;
                                flex: 5;
                            }
                            img{
                                flex: 2;
                                
                            }
                        }
                    }
                }
                .testc_system_item:nth-of-type(2){
                    .sub_score_box:nth-of-type(2n-1){
                        .el-collapse-item__header{
                            background-color: #3a6dd3!important;
                            background: #3a6dd3!important;
                        }
                        .el-collapse-item__wrap{
                            background-color: #3a6dd3!important;
                            .sub_score_item{
                                border-bottom: 1px solid #4e7cd8!important;
                            }
                            .sub_score_item_2{
                                border-bottom: 1px solid #4e7cd8!important;
                            }
                            .sub_score_item_2:nth-last-of-type(1){
                                    border-bottom: 0!important;
                            }
                        }
                        
                    }
                    .sub_score_box:nth-of-type(2n){
                        .el-collapse-item__header{
                            background-color: #1f5093!important;
                            background: #1f5093!important;
                        }
                        
                        .el-collapse-item__wrap{
                            background-color: #1f5093!important;
                            .sub_score_item{
                                border-bottom: 1px solid #325e9c!important;
                            }
                            .sub_score_item_2{
                                border-bottom: 1px solid #325e9c!important;
                            }
                            .sub_score_item_2:nth-last-of-type(1){
                                    border-bottom: 0!important;
                            }
                        }
                    }
                }
            }
        }
        .prospect{
            .prospect_t{
                background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/subtitle7.png) no-repeat center;
                width: 457px;
                height: 62px;
                margin:80px auto 30px;
            }
            .prospect_b{
                background-position: center top;
                background-repeat: no-repeat;
                width: 1182px;
                height: 146px;
                margin:0 auto;
                position: relative;
                p{
                    line-height: 30px;
                    text-align: center;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    width: 80%;
                }
            }
        }
        .qrcode{
            position: absolute;
            bottom: 203px;
            left: 13px;
            text-align: center;
            img{
                width: 200px;
            }
            p{
                margin-top: 10px;
                font-size: 24px;
                color:#e5e0ff;
            }
        }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/inside.vue